import React, {useCallback,useRef} from 'react'
import '../../assets/css/forms.scss';
import IntlTelInput from "react-intl-tel-input";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';

import InputMask from 'react-input-mask';
import { StickyContainer, Sticky } from 'react-sticky';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faTimesCircle,faPlusCircle,faTrash} from "@fortawesome/pro-regular-svg-icons";
import Actions from "../../helpers/actions";
import Select from "react-select";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Switch from "react-ios-switch/lib";
import Functions from "../../helpers/functions";
import ContentLoader from "react-content-loader";
import { Checkbox,Radio } from 'pretty-checkbox-react';
import Button from "../../components/button";
import {FormattedMessage} from "react-intl";
import {ClassicSpinner} from "react-spinners-kit";


const selectStyleMini = {
    option: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        position:'relative',
        zIndex:1005,
        height:30
    }),
}
const selectStyle = {
    option: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        position:'relative',
        zIndex:1005
    }),
}

class Item extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            target:this.props.target,
            index:this.props.index,
            id:null,
            description:this.props.data.description,
            quantity:this.props.data.quantity,
            unitPrice:this.props.data.unitPrice,
            hsCode:this.props.data.hsCode,
            netWeight:this.props.data.netWeight,
            grossWeight:this.props.data.grossWeight,
        };
    }
    componentDidMount(){

    }
    componentWillReceiveProps(nextProps){
        this.setState({
            index:nextProps.index,
            id:null,
            description:nextProps.data.description,
            quantity:nextProps.data.quantity,
            unitPrice:nextProps.data.unitPrice,
            hsCode:nextProps.data.hsCode
        })
    }
    renderHsCodeInput(){
        if(this.state.target == "productPrices" || this.state.target == "packingList"){
            return(
                <div className="columns small-12 medium-2 col hsCode">
                    <div className="input row collapse">
                        <div className="columns">
                            <input type={"text"} step="any" className={"textInput"} value={this.state.hsCode}  onChange={(e) => {
                                this.setState({hsCode:e.target.value},()=>{
                                    this.props.onChange(this.state);
                                });
                            }} />
                        </div>
                    </div>
                </div>
            );
        }
    }
    render(){
        switch(this.state.target){
            case "packingList":
                return (
                    <div className={"columns small-12 co"}>
                        <div className={"row"}>
                            <div className="columns small-12 medium-3 col">
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.description}  onChange={(e) => {
                                            this.setState({description:e.target.value},()=>{
                                                this.props.onChange(this.state);
                                            });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.hsCode}  onChange={(e) => {
                                            this.setState({hsCode:e.target.value},()=>{
                                                this.props.onChange(this.state);
                                            });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"number"} step="any" className={"textInput"} value={this.state.quantity}  onChange={(e) => {
                                            this.setState({quantity:e.target.value},()=>{
                                                this.props.onChange(this.state);
                                            });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.netWeight}  onChange={(e) => {
                                            this.setState({netWeight:e.target.value},()=>{
                                                this.props.onChange(this.state);
                                            });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"number"} step="any" className={"textInput"} value={this.state.grossWeight}  onChange={(e) => {
                                            this.setState({grossWeight:e.target.value},()=>{
                                                this.props.onChange(this.state);
                                            });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="columns col">
                                <div className="input row collapse align-right">
                                    <div className="columns shrink">
                                        <FontAwesomeIcon className={"close"} icon={faTrash} size="x2" onClick={()=>{
                                            this.props.removeItem(this.state.index);
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
                break;
            default:
                return (
                    <div className={"columns small-12 co"}>
                        <div className={"row"}>
                            <div className="columns small-12 medium-4 col">
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.description}  onChange={(e) => {
                                            this.setState({description:e.target.value},()=>{
                                                this.props.onChange(this.state);
                                            });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            {this.renderHsCodeInput()}
                            <div className="columns small-12 medium-2 col">
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"number"} step="any" className={"textInput"} value={this.state.quantity}  onChange={(e) => {
                                            this.setState({quantity:e.target.value},()=>{
                                                this.props.onChange(this.state);
                                            });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-3 col">
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"number"} step="any" className={"textInput"} value={this.state.unitPrice}  onChange={(e) => {
                                            this.setState({unitPrice:e.target.value},()=>{
                                                this.props.onChange(this.state);
                                            });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="columns col">
                                <div className="input row collapse align-right">
                                    <div className="columns shrink">
                                        <FontAwesomeIcon className={"close"} icon={faTrash} size="x2" onClick={()=>{
                                            this.props.removeItem(this.state.index);
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
                break;
        }
    }
}


export default class revisePapers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fid:(props.data.isRevise == true ?props.data.fid:0),
            isRevise:(props.data.isRevise == true?true:false),
            template:{value:"0",label:"Loading..."},
            formAvaliable:false,
            savingForm:false,
            disabled:false,
            aggreementAccepted:false,
            tabIndex:0,
            offerName:props.data.offerName,
            brand:props.data.brand,
            customer:props.data.customer,
            model:props.data.model,
            type:props.data.type,
            material:props.data.material,
            data: {
                groups:[]
            },
            inputs:{},
            currencies:[
                { value: "TRY", label: "TRY" },
                { value: "USD", label: "USD" },
                { value: "EUR", label: "EUR" },
                { value: "RUB", label: "RUB" },
                { value: "CAD", label: "CAD" },
                { value: "JPY", label: "JPY" }
            ],
            currency:{ value: "EUR", label: "EUR" },
            bankAccounts:null,
            activeBankAccounts:[],
            bankAccount:{ value: 0, label: "Loading" },
            companies:[],
            offerCompany:{ value: 0, label: "Loading" },
            proformaCompany:{ value: 0, label: "Loading" },
            packageListCompany:{ value: 0, label: "Loading" },
            commercialOffer:{
                "id": null,
                "bankAccount":{
                    id:0
                },
                "offerCompany":{
                    id:0
                },
                "proformaCompany":{
                    id:0
                },
                "packageListCompany":{
                    id:0
                },
                "paymentTerms": "",
                "deliveryTerms": "",
                "shippingTerms": "",
                "deliveryDate": "",
                "warranty": "",
                "offervalidity": "",
                "options": null,
                "currency":"EUR",
                "productPrices": [{
                    "id": null,
                    "description": "",
                    "quantity": 0,
                    "unitPrice": 0,
                    "hsCode": 0
                }],
                "optionPrices": [{
                    "id": null,
                    "description": "",
                    "quantity": 0,
                    "unitPrice": 0
                }],
                "packingList": [{
                    "id": null,
                    "description": "",
                    "quantity": 0,
                    "unitPrice": 0,
                    "hsCode": 0,
                    "netWeight": 0,
                    "grossWeight": 0
                }],
                "customerTaxId":"",
                "importNumber":"",
                "numberOfPieces":0,
                "totalGrossWeight":0,
                "totalNetWeigth":"",
                "countryOfOrigin":""
            },
        };

    }
    componentDidMount(){
        if(this.state.isRevise){
            this.getOfferData(this.state.fid);
        } else {
            this.getTemplate(this.props.data.type.templateCode);
        }
    }
    async getBankAccounts(){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI(
                "/company/bankAccounts",{}
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                var accounts = [];
                accounts.push({ value: 0, label: "Select Bank Account" });

                var bankAccount = { value: 0, label: "Select Bank Account" };

                var index = 0;
                response.data.forEach((data,i)=>{
                    accounts.push({ value: data["id"], label: data["bankName"], currency:data["currency"] });
                    if(index == 1){
                        index = i;
                    }
                    if(this.state.commercialOffer.bankAccount != null){
                        if(this.state.commercialOffer.bankAccount.id == data["id"]){
                            bankAccount = { value: data["id"], label: data["bankName"] };
                        }
                    }
                });

                var commercialOffer = this.state.commercialOffer;

                commercialOffer.bankAccount = {
                    id:bankAccount.value
                }

                this.setState({
                    commercialOffer,
                    bankAccount:bankAccount,bankAccounts:accounts
                },()=>{
                    var activeBankAccounts = [];
                    accounts.forEach((account,i)=>{
                        if(this.state.currency.value == account.currency){
                            activeBankAccounts.push(account);
                        }
                    });
                    this.setState({
                        activeBankAccounts:activeBankAccounts
                    })
                });
            } else {

            }
        } catch(error) {

        }
    }
    async getCompanies(){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI(
                "/company/get",{}
            );
            var response = await fetch(url.address, url.header);
            response = await response.json();
            var companies = [];
            companies.push({ value: 0, label: "Select Company" });

            var offerCompany = { value: 0, label: "Select Company" };
            var proformaCompany = { value: 0, label: "Select Company" };
            var packageListCompany = { value: 0, label: "Select Company" };

            var index = 0;
            response.data.forEach((data,i)=>{
                companies.push({ value: data["id"], label: data["brandName"] });
                if(index == 1){
                    index = i;
                }

                if(this.state.commercialOffer.offerCompany != null){
                    if(this.state.commercialOffer.offerCompany.id == data["id"]){
                        offerCompany = { value: data["id"], label: data["brandName"] };
                    }
                }
                if(this.state.commercialOffer.proformaCompany != null){
                    if(this.state.commercialOffer.proformaCompany.id == data["id"]){
                        proformaCompany = { value: data["id"], label: data["brandName"] };
                    }
                }
                if(this.state.commercialOffer.packageListCompany != null){
                    if(this.state.commercialOffer.packageListCompany.id == data["id"]){
                        packageListCompany = { value: data["id"], label: data["brandName"] };
                    }
                }
            });


            var commercialOffer = this.state.commercialOffer;

            commercialOffer.offerCompany = {
                id:offerCompany.value
            }
            commercialOffer.proformaCompany = {
                id:proformaCompany.value
            }
            commercialOffer.packageListCompany = {
                id:packageListCompany.value
            }


            this.setState({
                commercialOffer,
                offerCompany:offerCompany,proformaCompany:proformaCompany,packageListCompany:packageListCompany,companies:companies
            });
        } catch(error) {

        }
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.data["done"] == true && !this.state.formAvaliable){
            this.setState({
                offerName:nextProps.data.offerName,
                brand:nextProps.data.brand,
                customer:nextProps.data.customer,
                model:nextProps.data.model,
                type:nextProps.data.type,
                material:nextProps.data.material,
            });
            this.getTemplate(nextProps.data.type.templateCode);
        }
    }

    async getOfferData(id){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI(
                "/offers/get",
                {
                    id:id
                }
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.setState({data:response.data.data,commercialOffer:response.data.commercialOffers[0]},()=>{
                    var inputs = {};
                    this.state.data.groups.forEach((group,i)=>{
                        group.lines.forEach((line,i)=>{
                            line.columns.map((column,j)=>{
                                inputs["select_"+column.id+"_"+j] = ((column.value != null?true:false));
                            });
                        });
                    });
                    this.setState({inputs:inputs,formAvaliable:true},()=>{
                        this.getCompanies();
                        this.getBankAccounts();
                    });
                });
            } else {

            }
        } catch(error) {

        }
    }
    async getTemplateWithdata(id){
        this.setState({loading:true});

        this.setState({formAvaliable:false,data:[]});
        try {
            var url = Functions.generateURI(
                "/templates/get/offer",
                {
                    id:id,
                    withData:true
                }
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.setState({formAvaliable:true,data:response.data.data},()=>{
                    var inputs = {};
                    this.state.data.groups.forEach((group,i)=>{
                        group.lines.forEach((line,i)=>{
                            line.columns.map((column,j)=>{
                                inputs["select_"+i+"_"+j] = (j == 0?true:false);
                            });
                        });
                    });
                    this.setState({inputs:inputs,formAvaliable:true});
                });
            } else {
                this.setState({formAvaliable:true});
            }
        } catch(error) {

        }
    }
    async getTemplate(id){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI(
                "/templates/get",
                {
                    id:id
                }
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.setState({data:response.data},()=>{
                    var inputs = {};
                    this.state.data.groups.forEach((group,f)=>{
                        group.lines.forEach((line,i)=>{
                            line.columns.map((column,j)=>{
                                inputs["select_"+column.id+"_"+j] = (j == 0?true:false);
                            });
                        });
                    });
                    this.setState({inputs:inputs,formAvaliable:true},()=>{
                    });
                });
            } else {

            }
        } catch(error) {

        }
    }
    handleChange = address => {
        this.setState({ address });
    };

    handleSelect = address => {
        this.setState({address:address});
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                this.setState({
                    center:{lat:latLng.lat,lng:latLng.lng}
                });
                this.map.panTo({lat:latLng.lat,lng:latLng.lng});
            })
            .catch(error => console.error('Error', error));
    }
    renderColumns(columns,target,i,isActive){
        var types = ["text","text","text","text","date"];
        return columns.map((data,j)=>{
            var options = [];

            var selected = null;
            if(data.options != null){
                options.push({id:"-1", value: "-1", label: "Cancel selection"});
                data.options.forEach((option)=>{
                    options.push({id:option.id, value: option.optionValue, label: option.optionName});
                    if(data.value != null){
                        if(data.value.value == option.optionValue){
                            selected = {id:option.id, value: option.optionValue, label: option.optionName}
                        }
                    }
                });
            }

            var input;
            if(options.length > 0){
                input = <Select
                    styles={selectStyle}
                    value={selected}
                    onChange={(val)=>{
                        var inputs = this.state.inputs;
                        if(typeof columns[j + 1] == "object"){
                            inputs["select_"+columns[j + 1].id+"_"+(j + 1)] = true;
                        }

                        var newData = this.state.data;
                        this.state.data[target].forEach((group,x)=>{
                            group.lines.forEach((line,y)=>{
                                line.columns.map((column,z)=>{
                                    if(data.id == column.id){
                                        newData[target][x].lines[y].columns[z].value = val;
                                    }
                                });
                            });
                        });
                        this.setState({inputs:inputs,data:newData});
                    }}
                    options={options}
                />;
            } else {
                switch(data.type){
                    case 4:
                        break;
                    default:
                        break;
                }
                input = <input type={types[data.type]} step="any" className={"textInput"} value={(data.value != null?data.value.value:null)}  onChange={(e) => {

                    var inputs = this.state.inputs;
                    inputs["select_"+data.id+"_"+(j + 1)] = true;

                    var newData = this.state.data;
                    this.state.data[target].forEach((group,x)=>{
                        group.lines.forEach((line,y)=>{
                            line.columns.map((column,z)=>{
                                if(data.id == column.id){
                                    newData[target][x].lines[y].columns[z].value = {value:e.target.value};
                                }
                            });
                        });
                    });

                    this.setState({inputs:inputs,data:newData});
                }} />
            }

            return(
                <div className={"columns small-12 medium-4 col "+(this.state.inputs["select_"+data.id+"_"+j] == true || j == 0?" active":" passive")}>
                    <div className={"title"}>{(data.name != ""?data.name:"")}&nbsp;</div>
                    <div className={"input row collapse"}>
                        <div className={"columns"}>
                            {input}
                        </div>
                        <div className={"columns shrink"}>
                            <div className={"prefix"}>{data.prefix}</div>
                        </div>
                    </div>
                </div>
            );
        });
    }
    setCommercialOfferData(key,value){
        var commercialOffer = this.state.commercialOffer;
        commercialOffer[key] = value;
        this.setState({commercialOffer:commercialOffer});
    }
    renderCommercialOffer(){
        return(
            <div id={"commercialOffer"}>
                <div className="field row collapse">
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">COMPANIES</div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-4 col">
                                <div className="title">OFFER&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <Select
                                            className={"bankSelection"}
                                            styles={selectStyleMini}
                                            value={this.state.offerCompany}
                                            onChange={(val)=>{
                                                this.setCommercialOfferData("offerCompany",{
                                                    id:val.value
                                                })
                                                this.setState({
                                                    offerCompany:val
                                                })
                                            }}
                                            options={this.state.companies}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">PRODUCTS</div>
                            <div className={"columns shrink"}>
                                <FontAwesomeIcon className={"close"} icon={faPlusCircle} size="x2" onClick={()=>{
                                    this.addItem("productPrices")
                                }}/>
                            </div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">CURRENCY&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <Select
                                            className={"bankSelection"}
                                            styles={selectStyleMini}
                                            value={this.state.currency}
                                            onChange={(val)=>{
                                                this.setState({currency:val},()=>{
                                                    var activeBankAccounts = [];
                                                    this.state.bankAccounts.forEach((account,i)=>{
                                                        if(val.value == account.currency){
                                                            activeBankAccounts.push(account);
                                                        }
                                                    });
                                                    this.setState({activeBankAccounts:activeBankAccounts});
                                                });
                                                this.setCommercialOfferData("currency",val.value)
                                            }}
                                            options={this.state.currencies}
                                        />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-4 col">
                                <div className="title">DESCRIPTION&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-2 col hsCode">
                                <div className="title">HS CODE&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="title">QTY&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-3 col">
                                <div className="title">UNIT PRICE&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-1 col">
                                <div className="title">&nbsp;</div>
                            </div>
                        </div>
                        <div className="row columnList active">
                            {this.renderItems("productPrices")}
                        </div>
                    </div>
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">OPTIONS</div>
                            <div className={"columns shrink"}>
                                <FontAwesomeIcon className={"close"} icon={faPlusCircle} size="x2" onClick={()=>{
                                    this.addItem("optionPrices")
                                }}/>
                            </div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-4 col">
                                <div className="title">DESCRIPTION&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="title">QTY&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-3 col">
                                <div className="title">UNIT PRICE&nbsp;</div>
                            </div>
                            <div className="columns col">
                                <div className="title">&nbsp;</div>
                            </div>
                        </div>
                        <div className="row columnList active">
                            {this.renderItems("optionPrices")}
                        </div>
                    </div>
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">TERMS</div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-4 col">
                                <div className="title">COUNTRY OF ORIGIN&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.countryOfOrigin}  onChange={(e) => {
                                            this.setCommercialOfferData("countryOfOrigin",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-4 col">
                                <div className="title">WARRANTY&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.warranty}  onChange={(e) => {
                                            this.setCommercialOfferData("warranty",e.target.value);
                                        }} />
                                    </div>
                                    <diwv className="columns shrink">
                                        <div className="prefix"></div>
                                    </diwv>
                                </div>
                            </div>
                            <div className="columns small-12 medium-4 col">
                                <div className="title">VALIDITY&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.offervalidity}  onChange={(e) => {
                                            this.setCommercialOfferData("offervalidity",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">PAYMENT TERMS&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.paymentTerms}  onChange={(e) => {
                                            this.setCommercialOfferData("paymentTerms",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">DELIVERY TERMS&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.deliveryTerms}  onChange={(e) => {
                                            this.setCommercialOfferData("deliveryTerms",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">SHIPPING TERMS&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.shippingTerms}  onChange={(e) => {
                                            this.setCommercialOfferData("shippingTerms",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    renderProformaInvoice(){
        return(
            <div>
                <div className="field row collapse">
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">COMPANIES</div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-4 col">
                                <div className="title">INVOICE&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <Select
                                            className={"bankSelection"}
                                            styles={selectStyleMini}
                                            value={this.state.proformaCompany}
                                            onChange={(val)=>{
                                                this.setCommercialOfferData("proformaCompany",{
                                                    id:val.value
                                                })
                                                this.setState({
                                                    proformaCompany:val
                                                })
                                            }}
                                            options={this.state.companies}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">PRODUCTS</div>
                            <div className={"columns shrink"}>
                                <FontAwesomeIcon className={"close"} icon={faPlusCircle} size="x2" onClick={()=>{
                                    this.addItem("productPrices")
                                }}/>
                            </div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">CURRENCY&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <Select
                                            className={"bankSelection"}
                                            styles={selectStyleMini}
                                            value={this.state.currency}
                                            onChange={(val)=>{
                                                this.setState({currency:val},()=>{
                                                    var activeBankAccounts = [];
                                                    this.state.bankAccounts.forEach((account,i)=>{
                                                        if(val.value == account.currency){
                                                            activeBankAccounts.push(account);
                                                        }
                                                    });
                                                    this.setState({activeBankAccounts:activeBankAccounts});
                                                });
                                                this.setCommercialOfferData("currency",val.value)
                                            }}
                                            options={this.state.currencies}
                                        />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-4 col">
                                <div className="title">DESCRIPTION&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="title">HS CODE&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="title">QTY&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-3 col">
                                <div className="title">UNIT PRICE&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-1 col">
                                <div className="title">&nbsp;</div>
                            </div>
                        </div>
                        <div className="row columnList active">
                            {this.renderItems("productPrices")}
                        </div>
                    </div>
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">TERMS</div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-4 col">
                                <div className="title">COUNTRY OF ORIGIN&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.countryOfOrigin}  onChange={(e) => {
                                            this.setCommercialOfferData("countryOfOrigin",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">PAYMENT TERMS&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.paymentTerms}  onChange={(e) => {
                                            this.setCommercialOfferData("paymentTerms",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">DELIVERY TERMS&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.deliveryTerms}  onChange={(e) => {
                                            this.setCommercialOfferData("deliveryTerms",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">SHIPPING TERMS&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.shippingTerms}  onChange={(e) => {
                                            this.setCommercialOfferData("shippingTerms",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">PROFORMA INVOICE</div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-4 col">
                                <div className="title">CUSTOMER TAX ID&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.customerTaxId}  onChange={(e) => {
                                            this.setCommercialOfferData("customerTaxId",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-4 col">
                                <div className="title">IMPORT NUMBER&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.importNumber}  onChange={(e) => {
                                            this.setCommercialOfferData("importNumber",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-4 col">
                                <div className="title">NUMBER OF PIECES&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"number"} step="any" className={"textInput"} value={this.state.commercialOffer.numberOfPieces}  onChange={(e) => {
                                            this.setCommercialOfferData("numberOfPieces",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-4 col">
                                <div className="title">TOTAL GROSS WEIGHT&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.totalGrossWeight}  onChange={(e) => {
                                            this.setCommercialOfferData("totalGrossWeight",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-4 col">
                                <div className="title">TOTAL NET WEIGHT&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.totalNetWeigth}  onChange={(e) => {
                                            this.setCommercialOfferData("totalNetWeigth",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">BANK DETAILS</div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-4 col">
                                <div className="title">CURRENCY&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <Select
                                            className={"bankSelection"}
                                            styles={selectStyleMini}
                                            value={this.state.currency}
                                            onChange={(val)=>{
                                                this.setState({currency:val},()=>{
                                                    var activeBankAccounts = [];
                                                    this.state.bankAccounts.forEach((account,i)=>{
                                                        if(val.value == account.currency){
                                                            activeBankAccounts.push(account);
                                                        }
                                                    });
                                                    this.setState({activeBankAccounts:activeBankAccounts});
                                                });
                                                this.setCommercialOfferData("currency",val.value)
                                            }}
                                            options={this.state.currencies}
                                        />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-8 col active">
                                <div className="title">BANK ACCOUNT&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <Select
                                            className={"bankSelection"}
                                            styles={selectStyleMini}
                                            value={this.state.bankAccount}
                                            onChange={(val)=>{
                                                this.setCommercialOfferData("bankAccount",{
                                                    id:val.value
                                                })
                                                this.setState({
                                                    bankAccount:val
                                                })
                                            }}
                                            options={this.state.activeBankAccounts}
                                        />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    renderPackingList(){
        return(
            <div>
                <div className="field row collapse">
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">COMPANIES</div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-12 col">
                                <div className="title">PACKAGE LIST&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <Select
                                            className={"bankSelection"}
                                            styles={selectStyleMini}
                                            value={this.state.packageListCompany}
                                            onChange={(val)=>{
                                                this.setCommercialOfferData("packageListCompany",{
                                                    id:val.value
                                                })
                                                this.setState({
                                                    packageListCompany:val
                                                })
                                            }}
                                            options={this.state.companies}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">TERMS</div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-4 col">
                                <div className="title">COUNTRY OF ORIGIN&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.countryOfOrigin}  onChange={(e) => {
                                            this.setCommercialOfferData("countryOfOrigin",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">PAYMENT TERMS&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.paymentTerms}  onChange={(e) => {
                                            this.setCommercialOfferData("paymentTerms",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">DELIVERY TERMS&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.deliveryTerms}  onChange={(e) => {
                                            this.setCommercialOfferData("deliveryTerms",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns small-12 medium-12 col active">
                                <div className="title">SHIPPING TERMS&nbsp;</div>
                                <div className="input row collapse">
                                    <div className="columns">
                                        <input type={"text"} step="any" className={"textInput"} value={this.state.commercialOffer.shippingTerms}  onChange={(e) => {
                                            this.setCommercialOfferData("shippingTerms",e.target.value);
                                        }} />
                                    </div>
                                    <div className="columns shrink">
                                        <div className="prefix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="columns small-12 medium-12">
                        <div className="row title">
                            <div className="columns">PACKING LIST</div>
                            <div className={"columns shrink"}>
                                <FontAwesomeIcon className={"close"} icon={faPlusCircle} size="x2" onClick={()=>{
                                    this.addItem("packingList")
                                }}/>
                            </div>
                        </div>
                        <div className="row columnList active">
                            <div className="columns small-12 medium-3 col">
                                <div className="title">DESCRIPTION&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-2 col hsCode">
                                <div className="title">HS CODE&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="title">QTY&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-2 col">
                                <div className="title">NET WEIGHT&nbsp;</div>
                            </div>
                            <div className="columns small-12 medium-3 col">
                                <div className="title">GROSS WEIGHT&nbsp;</div>
                            </div>
                        </div>
                        <div className="row columnList active">
                            {this.renderItems("packingList")}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    addItem(target){
        var commercialOffer = this.state.commercialOffer;
        commercialOffer[target].push({
            "id": null,
            "description": "",
            "hsCode": "",
            "quantity": 0,
            "unitPrice": 0,
            "netWeight": 0,
            "grossWeight": 0,
        });
        this.setState({commercialOffer:commercialOffer});
    }
    editItem(target,index,description,qty,price,hsCode,netWeight,grossWeight){
        var commercialOffer = this.state.commercialOffer;
        commercialOffer[target][index] = {
            "id": null,
            "description": description,
            "hsCode": hsCode,
            "quantity": qty,
            "unitPrice": price,
            "netWeight": netWeight,
            "grossWeight": grossWeight,
        }
        this.setState({commercialOffer:commercialOffer});
    }
    removeItem(target,index){
        var commercialOffer = this.state.commercialOffer;
        commercialOffer[target].splice(index, 1);
        this.setState({commercialOffer:commercialOffer});
    }
    renderItems(target){
        return this.state.commercialOffer[target].map((item,i)=>{
           return(
               <Item data={item} target={target} index={i}
                     onChange={(data)=>{
                         this.editItem(target,data.index,data.description,data.quantity,data.unitPrice,data.hsCode,data.netWeight,data.grossWeight);
                   }} removeItem={(index)=>{
                       this.removeItem(target,index);
                   }}
               />
           );
        });
    }
    renderFormWrapper(){
        if(this.state.formAvaliable){
            return(
                <Tabs style={{height:(window.innerHeight - 102)+"px"}} selectedIndex={this.state.tabIndex} onSelect={(tabIndex) => {
                    this.setState({ tabIndex },()=>{
                        var contentView = document.getElementById('contentView');
                        contentView.scrollTop = 0;
                    });
                }}>
                    <TabList>
                        <Tab><div style={{color:"red"}}>COMMERCIAL OFFER</div></Tab>
                        <Tab><div style={{color:"red"}}>PROFORMA INVOICE</div></Tab>
                        <Tab><div style={{color:"red"}}>PACKING LIST</div></Tab>
                        <Tab><div style={{color:"red"}}>OTHER</div></Tab>
                    </TabList>
                    <div className={"container"} id={"contentView"}>
                        <TabPanel>
                            {this.renderCommercialOffer()}
                        </TabPanel>
                        <TabPanel>
                            {this.renderProformaInvoice()}
                        </TabPanel>
                        <TabPanel>
                            {this.renderPackingList()}
                        </TabPanel>
                    </div>
                </Tabs>
            )
        } else {
            return(
                <div style={{height:"100%"}}>
                    <ContentLoader
                        height={40}
                    >
                        <rect x="5" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="90" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="180" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="270" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="330" y="5" rx="4" ry="4" width="70" height="8" />
                    </ContentLoader>
                    <ContentLoader
                        height={140}
                    >
                        {this.renderShimmers()}
                    </ContentLoader>
                </div>
            )
        }
    }
    renderShimmers(){
        var shimmers = [{},{},{},{},{},{},{},{},{},{}];
        return shimmers.map((data,i)=>{
            return(
                <rect x="5" y={(i * 16)} rx="4" ry="4" width="395" height="10" />
            );
        })
    }
    render(){
        var thiz = this;
        return (
            <StickyContainer>
                <div id={"requestForm"}>
                    <div className={"header row"}>
                        <div className={"columns shrink"}>
                            <div className={"title"}>
                                <b>{(this.state.isRevise?"Manage Papers":this.state.customer.label)}</b>
                                <small>{(this.state.isRevise?"":this.state.model.label+" - "+this.state.type.label)}</small>
                            </div>
                        </div>
                        <div className={"columns"}>

                        </div>
                        <div className={"columns shrink"}>
                            <FontAwesomeIcon className={"close"} icon={faTimesCircle} size="x2" onClick={()=>{
                                this.setState({formAvaliable:false,savingForm:false},()=>{
                                    Actions.emit("closeSidePanel");
                                })
                            }}/>
                        </div>
                    </div>
                    {this.renderFormWrapper() }
                    <div className={"footer"}>
                        <div className={"row"}>
                            <div className={"columns"}>
                                <Checkbox name="aggreement" color="primary-o" disabled={(this.state.savingForm?true:false)} animation="smooth" value={1}  checked={(this.state.aggreementAccepted?true:false)} onChange={(e) => {
                                    this.setState({aggreementAccepted:!this.state.aggreementAccepted})
                                }}>I have checked all the information and confirm</Checkbox>
                            </div>
                            <div className={"columns shrink"}>
                                <Button buttonTitle={"button.create"} loadingTitle={"button.creating"} loading={this.state.savingForm} disabled={(!this.state.aggreementAccepted || this.state.disabled?true:false)} onClick={()=>{
                                    this.createOrder();

                                }}/>
                            </div>
                        </div>
                    </div>

                </div>
            </StickyContainer>
        );
    }
    async createOrder(){
        if(this.state.aggreementAccepted){
            try {
                var data = this.state.commercialOffer;

                this.setState({loading:true,savingForm:true,disabled:true});
                var url = Functions.generateURI("/offers/commercialOffer",{
                    fid:this.state.fid,
                    commercialOffer:data,
                    method:"POST"
                });
                var response = await fetch(url.address, url.header);
                response = await response.json();

                if(response.status){
                    this.setState({formAvaliable:false,savingForm:false,disabled:false},()=>{
                        Actions.emit("closeSidePanel");
                    });
                } else {

                }
            } catch(error) {

            }
        }
    }
}

